module.exports = __webpack_public_path__ + "img/user-3.871b0080.png";